import React, { useState, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import './Footer.css';
import logo from '../Logos/LogoElefanteBordesBlancos.png';

const ADMIN_ROUTE_PREFIXES = [
  '/admin',
  '/subscriptores',
  '/editor-masivo',
  '/historial-ventas',
  '/reporte-de-ventas',
  '/analiticas',
  '/local',
  '/configuracion-descuentos',
  '/gestion-stock',
  '/balance',
  '/costo-envios',
  '/factory',
  '/newsletter',
  '/facturador',
];

const Footer = () => {
  const location = useLocation();
  const [isFooterVisible, setIsFooterVisible] = useState(false);

  useEffect(() => {
    const footerTimer = setTimeout(() => {
      setIsFooterVisible(true);
    }, 900);

    return () => {
      clearTimeout(footerTimer);
    };
  }, []);

  const isAdminRoute = ADMIN_ROUTE_PREFIXES.some(
    (prefix) => location.pathname === prefix || location.pathname.startsWith(`${prefix}/`)
  );

  return (
    <footer className={`site-footer ${isFooterVisible ? 'site-footer--visible' : 'site-footer--hidden'} ${isAdminRoute ? 'site-footer--admin' : ''}`}>
      <div className="site-footer__glow" aria-hidden="true" />
      {isAdminRoute ? (
        <div className="site-footer__admin-brand" aria-label="Panel administrativo">
          <span className="site-footer__eyebrow">Backoffice</span>
          <strong>PRIVISTORE</strong>
        </div>
      ) : (
        <div className="site-footer__content">
          <div className="site-footer__brand">
            <img src={logo} alt="Allegra Club House" className="site-footer__logo" />
            <div>
              <span className="site-footer__eyebrow">Club House</span>
              <h4>Allegra</h4>
            </div>
          </div>

          <div className="site-footer__meta" aria-label="Información de ubicación">
            <span className="site-footer__pill">Bell Ville</span>
            <p>Córdoba, Argentina</p>
          </div>

          <div className="site-footer__line" aria-hidden="true" />

          <div className="site-footer__copy">
            <p>Experiencias, entradas y comunidad.</p>
          </div>
        </div>
      )}
    </footer>
  );
};

export default Footer;
